import image1 from "../static/location/image1.jpg"
import image2 from "../static/location/image2.jpg"
import image3 from "../static/location/image3.jpg"

import post2 from "../static/news/post2.webp"
import post3 from "../static/news/post3.webp"
import post5_1 from "../static/posts/post5_1.webp"
import post5_2 from "../static/posts/post5_2.webp"
import post6_1 from "../static/posts/post6_1.webp"
import post6_2 from "../static/posts/post6_2.webp"
import post7 from "../static/news/post7.webp"
import post8_2 from "../static/posts/post8_2.jpeg"
import post9 from "../static/news/post9.webp"
import post10 from "../static/news/post10.webp"
import post11 from "../static/news/post11.webp"
import post8 from "../static/news/post8.webp"
import post12 from "../static/news/post12.webp"
import post10_1 from "../static/posts/post10_1.webp"
import post10_2 from "../static/posts/post10_2.webp"
import post10_3 from "../static/posts/post10_3.webp"
import post10_4 from "../static/posts/post10_4.webp"
import post10_5 from "../static/posts/post10_5.webp"
import post12_1 from "../static/posts/post12_1.webp"
import post12_2 from "../static/posts/post12_2.webp"



export const postsContent = [
    {
       id: 1,
       title: 'Мы по новому адресу',
       content: "Дорогие ребята! Уважаемые родители!\n" +
           "Гильдия репетиторов «Триумф» в настоящее время располагается по адресу: ул. Жуковского, дом 8, офис 313.\n" +
           "Остановки транспорта - ул. Гоголя, театр им. К. Тинчурина (стадион Динамо) или площадь Свободы. \n" +
           "\n" +
           "В новом учебном году ждём Вас по новому адресу!",
       images: [image1, image2, image3],
    },
    // {
    //     id: 2,
    //     title: '',
    //     content: "",
    //     images: [],
    // },
    {
        id: 2,
        title: 'ЕГЭ 2019 — результаты',
        content: "Наконец-то мы дождались результатов ЕГЭ! \n" +
            "Вот это урожай!!!\n" +
            "\n" +
            "Русский язык — 16 учеников:\n" +
            "4 (!!!) ученика получили 98 баллов,\n" +
            "2 — 96,\n" +
            "2 — 91,\n" +
            "2 — 89,\n" +
            "4 — 85,\n" +
            "1 — 82,\n" +
            "1 — 76.\n" +
            "Средний балл — 90, 125!!!\n" +
            "\n" +
            "Математика — 6 учеников:\n" +
            "Баллы — 80, 78, 72, 70 и два по 68.\n" +
            "Средний балл — 72, 6!!!\n" +
            "\n" +
            "Обществознание — 3 ученика:\n" +
            "Баллы — 89, 72, 67.\n" +
            "Средний балл — 76!!!\n" +
            "\n" +
            "Поздравляем, ребята! В добрый путь! ",
        images: [post2],
    },
    {
        id: 3,
        title: 'Объявление о наборе',
        content: "Дорогие ребята и уважаемые родители!\n" +
            "«Гильдия репетиторов ТРИУМФ» объявляет о наборе в группы по подготовке к ОГЭ и ЕГЭ на 2019-20 учебный год по предметам: русский язык, математика, обществознание, информатика и др.\n" +
            "Занятия проводят ведущие преподаватели вузов, имеющие опыт работы со школьниками. \n" +
            "Начало занятий - 9 сентября. Далее - по мере поступления заявок.\n" +
            "Запись по телефону: 258-97-59",
        images: [post3],
    },
    {
        id: 4,
        title: 'Итоговое сочинение 2019',
        content: "",
        images: [],
        video: "https://www.youtube.com/embed/4WWy3qXwnro?si=1J9jmvxjz8fENhj-"
    },
    {
        id: 5,
        title: 'Консультация по вопросам поступления в вузы РФ',
        content: "В «Гильдии репетиторов ТРИУМФ» прошла серия консультаций по вопросам поступления в вузы России и выбору специальности. Перед учащимися 11-ых классов и их родителями выступали Лопатин Алексей Александрович, проректор КНИТУ-КАИ по образовательной деятельности и воспитательной работе, и Фатхутдинов Ирек Маратович, руководитель отдела профориентационной работы. \n" +
            "\n" +
            "После консультации состоялась оживлённая беседа, во время которой обсуждались насущные для выпускников 2020 года вопросы: особенности обучения в вузах, перспективные направления, правила поступления в вузы, сроки подачи документов и, конечно, многие другие. \n" +
            "\n" +
            "Благодарим коллег за профессионально проведённые мероприятия и за предоставление важной для ребят информации!",
        images: [post5_1, post5_2],
    },
    {
        id: 6,
        title: 'Консультация по профориентации',
        content: "Календарный год в «Гильдии репетиторов ТРИУМФ» завершился консультацией по профориентации для учащихся 9-ых классов, которую в очередной раз провела кандидат психологических наук Екатерина Александровна Гопкало. Ребята получили рекомендации по выбору будущей сферы деятельности. ",
        images: [post6_1, post6_2],
    },
    {
        id: 7,
        title: 'Всероссийская научно-практическая конференция в КГМУ',
        content: "Ученики \"Гильдии репетиторов ТРИУМФ\" стали участниками Всероссийской  научно-практической конференции \"Национальный язык и культура в условиях глобализации\",  регулярно проводимой Казанским государственным медицинским университетом. Со статьями участников можно ознакомиться в опубликованном сборнике, который размещен в разделе \"Подготовка к экзаменам\". " +
            "\n" +
            "Буренина Дарья \"Категория вида как особая грамматическая категория глаголов\".\n" +
            "\n" +
            "Гордеева Анастасия \"Употребление терминов в художественном тексте (на примере цикла рассказов М.А.Булгакова «Записки юного врача»)\". \n" +
            "\n" +
            "Мангушева Аделина \"Роль средств выразительности в описании местности (на примере повести В.Г.Короленко «Дети подземелья»)\".\n" +
            "\n" +
            "Пуринсон Алиса \"Фигуры речи как средство характеристики героев (на примере романа Ф.М.Достоевского «Преступление и наказание»)\".\n" +
            "\n" +
            "Феоктистова Анастасия \"Основные принципы русской орфографии (краткий обзор в историческом ракурсе)\".\n" +
            "\n" +
            "Хасанов Роберт \"К вопросу о происхождении глаголицы и кириллицы как древнейших славянских азбук\".\n" +
            "\n" +
            "Шаймарданова Эльвина \"Крылатые слова как яркий признак нетленности произведения (на примере романа в стихах А.С.Пушкина «Евгений Онегин»)\". ",
        images: [post7],
    },
    {
        id: 8,
        title: 'Издание сборника вариантов ЕГЭ',
        content: "В апреле 2020 года Феоктистова Т.В. и Фахрутдинова М.Т. , преподаватели русского языка, издали сборник  типовых экзаменационных вариантов, который был необходим ребятам, особенно в  период дистанционного обучения.",
        images: [post8, post8_2],
    },
    {
        id: 9,
        title: 'ЕГЭ 2020 - результаты',
        content: "Озвучим результаты ЕГЭ 2020.\n" +
            "\n" +
            "Русский язык - 25 учеников:\n" +
            "6 из них набрали от 90 до 100 баллов, \n" +
            "5 - от 80 до 89 баллов, \n" +
            "9 - от 70 до 79 баллов,\n" +
            "5 - от 57 до 69 баллов.\n" +
            "Средний балл - 79.\n" +
            "\n" +
            "Математика - 5 учеников:\n" +
            "2 из них получили по 78 баллов,\n" +
            "остальные - 68, 56 и 50 баллов.\n" +
            "\n" +
            "Поздравляем Белова Максима, набравшего 100 баллов по русскому языку!\n" +
            "\n" +
            "Желаем всем ребятам успешного поступления в вузы!",
        images: [post9],
    },
    {
        id: 10,
        title: '',
        content: "",
        images: [post10, post10_1, post10_2, post10_3, post10_4, post10_5],
    },
    {
        id: 11,
        title: 'ЕГЭ 2022 - результаты\n',
        content: "Русский язык сдавали 40 учеников. Наивысший балл - 100!!! Средний балл - 80.  Результат 94 балла и более показали 12 человек!\n" +
            "Обществознание сдавали 10 человек. Наивысший балл - 94! Средний балл - 70.\n" +
            "Информатику сдавали 4 человека. Наивысший балл - 93!. Средний балл - 69.\n" +
            "Математику сдавали 2 человека. Их результаты 74 и 66 баллов.\n" +
            "Историю сдавали 2 человека. Их результаты 60 и 58 баллов.",
        images: [post11],
    },
    {
        id: 12,
        title: 'Новый филиал в Лаишево!\n',
        content: "",
        images: [post12, post12_1, post12_2],
    },


]

export default postsContent;